<template>
<v-container class="fill-height data-container" fluid>

    <v-stepper class="stepper" v-model="currentStep">

        <v-stepper-header style="height: 50px;">
            <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable color="#c42111" :rules="[() => validation.thresholdProfileStepForm($refs.thresholdProfileInfoForm)]">Threshold Profile Info</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable color="#c42111" :rules="[() => $props.thresholdProfile.thresholds.length > 0 && $props.thresholdProfile.thresholds.every(threshold => threshold.formValid == true)]">Reports</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable color="#c42111" :rules="[]">Sites</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="stepper-content-container">

            <v-stepper-content :step="1" class="stepper-content">
                <v-form ref="thresholdProfileInfoForm" @submit.prevent class="fill-height" :lazy-validation="true" v-model="thresholdProfileInfoFormValid">
                    <v-text-field label="Threshold Profile Name" color="#c42111" v-model="$props.thresholdProfile.tp_name" :rules="[validation.required($props.thresholdProfile.tp_name, 'Threshold Profile Name')]" />
                </v-form>
            </v-stepper-content>

            <v-stepper-content :step="2" class="stepper-content">
                <v-expansion-panels v-model="expandedPanels">
                    <v-expansion-panel class="mb-3" v-for="threshold in $props.thresholdProfile.thresholds" :key="threshold.thres_id" style="background-color: #303030;">
                        <v-expansion-panel-header style="text-align: left;">
                            <v-icon color="#ff5252" class="mr-2" style="max-width: 24px; margin-left: -5px;" v-if="!threshold.formValid">mdi-alert</v-icon>
                            <span v-html="buildThresholdTitleText(threshold)" />
                            <v-icon large color="#ff5252" style="max-width: 24px; position: absolute; right: 80px; top: 10px;" @click.stop="deleteThreshold(threshold)">mdi-delete-forever</v-icon>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <threshold-profile-threshold-edit :threshold="threshold" :thresholdProfile="$props.thresholdProfile" :thresholdResources="$props.thresholdResources" :lockSave="$props.lockSave"></threshold-profile-threshold-edit>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-btn class="mt-3 mr-0" color="#c42111" @click="addNewThreshold">Add Report</v-btn>
            </v-stepper-content>

            <v-stepper-content :step="3" class="stepper-content">
                <threshold-profile-site-select :allSitesList="thresholdResources.allSitesList" :selectedSitesIds="thresholdProfile.selected_sites" :allSitesUsed="$props.allSitesUsed" :tpId="thresholdProfile.tp_id"></threshold-profile-site-select>
            </v-stepper-content>

        </v-stepper-items>

    </v-stepper>

    <v-btn color="#c42111" class="mt-3 mr-3" @click="saveClick" :disabled="lockSave" >Save</v-btn>
    <v-btn color="#c42111" class="mt-3 mr-3" @click="$emit('cancel')">Cancel</v-btn>

</v-container>
</template>

<script>
import ThresholdProfileSiteSelect from "@/components/ThresholdProfiles/ThresholdProfileSiteSelect";
import ThresholdProfileThresholdEdit from "@/components/ThresholdProfiles/ThresholdProfileThresholdEdit";
export default {
    name: 'ThresholdProfileEdit',
    props: ['thresholdProfile', 'thresholdResources', 'allSitesUsed', 'lockSave'],
    components: {
        ThresholdProfileSiteSelect,
        ThresholdProfileThresholdEdit
    },
    data: () => ({
        thresholdProfileInfoFormValid: true,
        thresholdProfileReportsFormValid: true,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            thresholdProfileStepForm: (form) => ((form === undefined || form.validate()) || false),
        },
        currentStep: 1,
        expandedPanels: [],
    }),

    computed: {
    },

    methods: {
        buildThresholdTitleText: function(threshold) {
            let report = threshold.thres_obj.name;
            if(!report) {
                return "NEW";
            }
            let metric = threshold.thres_column != null ? threshold.thres_obj.columns[threshold.thres_column] : "No Metric";
            let thresholdValue = threshold.thres_test != null ? this.$props.thresholdResources.conditions[threshold.thres_test] : "No Condition";
            let value = threshold.thres_value || "No Value";
            let additionalCriteriaCount = threshold.thres_criteria.length;
            return `<span><b style="color: #c42111;">${report}:</b> ${metric} • ${thresholdValue} • ${value} • ${additionalCriteriaCount} Additional Criterias </span>`;
        },

        deleteThreshold: function(threshold) {
            let idx = this.thresholdProfile.thresholds.indexOf(threshold);
            this.thresholdProfile.thresholds.splice(idx, 1);
        },

        addNewThreshold: function() {
            const thresId = this.$props.thresholdProfile.tp_id;
            let newThreshold = {
                thres_column: '',
                thres_criteria: [],
                thres_days_fri: true,
                thres_days_mon: true,
                thres_days_sat: true,
                thres_days_sun: true,
                thres_days_thu: true,
                thres_days_tue: true,
                thres_days_wed: true,
                thres_hour_begin: '',
                thres_hour_end: '',
                //thres_id: ''
                thres_obj: {
                    columns: [],
                    defaults: [],
                    id: '',
                    name: '',
                },
                thres_severity: '',
                thres_test: '',
                thres_value: '',
                tp_id: this.$props.thresholdProfile.tp_id,
                user_obj_id: '',
                formValid: false
            };
            this.$props.thresholdProfile.thresholds.push(newThreshold);
        },

        saveClick: function() {
            let thresholdsValid = this.$props.thresholdProfile.thresholds.length > 0 && !this.$props.thresholdProfile.thresholds.some(threshold => threshold.formValid == false);
            if(this.$refs.thresholdProfileInfoForm.validate() && thresholdsValid) {
                this.$emit('save', this.thresholdProfile);
            }
        }
    },

    watch: {
        thresholdProfile: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            deep: true
        }
    },

    mounted() {
    },

    created() {
        for(let threshold of this.$props.thresholdProfile.thresholds) {
            threshold.formValid = true;
        }
    }

  
};
</script>

<style scoped>

    #tp-ag-grid-container {
        height: calc(100vh - 220px);
        width: 100%;
    }

    .stepper {
        background: #424242 !important; 
        height: calc(100vh - 126px);
        width: 100%;
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto; 
        height: calc(100% - 55px);
    }
    .stepper-content {
        /* padding: 16px 4px 4px 4px; */
    }

    .data-container {
        padding: 0;
    }

    .week-day {
        display: inline-block;
        margin-right: 3em;
    }

    .week-day-label {
        display: block;
        font-weight: bold;
    }

    .action-number {
        display: block;
        font-weight: bold;
        margin-top: calc(50%);
        font-size: 24px;
    }

</style>
